import { Typography, TypographyProps } from "@mui/material";

export type EventCardTopLabelProps = { date: string } & TypographyProps;

export const EventCardTopLabel: React.FC<EventCardTopLabelProps> = ({
    date,
    ...props
}) => {
    return (
        <Typography
            variant="label2"
            textTransform="uppercase"
            color="text.secondary"
            data-testid="event-card-top-label"
            {...props}
        >
            {date}
        </Typography>
    );
};
